module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"jinmac.org-website","short_name":"jinmac","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/assets/images/logos/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6ecb08d5732469025b24f3f78eb99839"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
